import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const grantsData: NavItem[] = [
  {
    label: 'About',
    to: '/pages/grants/about'
  },
  {
    label: 'Documentation',
    to: '/pages/grants/documentation'
  },
  {
    label: 'Terms',
    to: '/pages/grants/terms'
  },
  {
    label: 'Process',
    to: '/pages/grants/process'
  },
  {
    label: 'Stats',
    to: '/pages/grants/stats'
  }
];
